import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../redux/actions/analytics";

const monthAbbrs = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const chartConfig = {
  activeUsersPerYear: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
  activeUsersPerMonth: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
  activeUsersPerDay: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
  usersPerYear: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
  usersPerMonth: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
  usersPerDay: {
    options: {
      chart: {
        height: 245,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      plotOptions: {},
      dataLabels: {
        enabled: false,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [
          // Calculated dinamically
        ],
        position: "bottom",
        crosshairs: {
        },
        tooltip: {
          enabled: true,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
    },
  },
};

export default function RestlessAnalyticsPage() {
  const dispatch = useDispatch();

  const {
    pieRole,
    pieRoleLoading,
    activeMembersYear,
    activeMembersMonth,
    activeMembersToday,
    // appInstallations,
    usersPerDay,
    usersPerMonth,
    usersPerYear,
    usersTotal,
    usersToday,
    activeUsersPerYear,
    activeUsersPerMonth,
    activeUsersPerDay,
  } = useSelector((state) => ({
    pieRole: state.analytics.pieRole,
    pieRoleLoading: state.analytics.pieRoleLoading,
    activeMembersYear: state.analytics.activeMembersYear,
    activeMembersMonth: state.analytics.activeMembersMonth,
    activeMembersToday: state.analytics.activeMembersToday,
    // appInstallations: state.analytics.appInstallations,
    usersPerDay: state.analytics.usersPerDay,
    usersPerMonth: state.analytics.usersPerMonth,
    usersPerYear: state.analytics.usersPerYear,
    usersTotal: state.analytics.usersTotal,
    usersToday: state.analytics.usersToday,
    activeUsersPerYear: state.analytics.activeUsersPerYear,
    activeUsersPerMonth: state.analytics.activeUsersPerMonth,
    activeUsersPerDay: state.analytics.activeUsersPerDay,
  }));

  useEffect(() => {
    // Step 1: Date ranges
    const today = new Date();

    // Tiranically hardcoded value
    const initialYear = 2019;

    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();

    const currentMonthString = currentYear.toString() + '-' +
      ((currentMonth < 10) ? '0' + currentMonth.toString() : currentMonth.toString());

    const currentDayString = currentMonthString + '-' +
      ((currentDay < 10) ? '0' + currentDay.toString() : currentDay.toString());

    // Years since 2019 to the present...
    let yearsList = [];
    let pivot = initialYear;

    while (pivot <= currentYear) {
      yearsList.push(pivot.toString());
      pivot++;
    }

    // Last 12 months...
    let monthList = [];
    let m_labels = [];
    let y = currentYear;
    let m = currentMonth;

    for (let i = 0; i < 12; i++) {
      if (m < 10) {
        monthList.push(y + '-0' + (m).toString());
      } else {
        monthList.push(y + '-' + (m).toString());
      }

      m_labels.push(monthAbbrs[m - 1]);

      m--;

      if (m < 1) {
        m = 12;
        y--;
      }
    }

    monthList.reverse();
    m_labels.reverse();

    // Latest 30 days...
    let daysList = [];
    let d = today;

    for (let i = 1; i <= 30; i++) {
      
      const dayString = d.getFullYear().toString() + '-' +
        (((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1).toString() : (d.getMonth() + 1).toString()) + '-' +
        ((d.getDate() < 10) ? '0' + d.getDate().toString() : d.getDate().toString());

      daysList.push(dayString);

      // Code to calculate the previous day...
      d = new Date(new Date().setDate(today.getDate() - i));
    }

    daysList.reverse();

    // Step 2: Labels
    chartConfig.activeUsersPerYear.options.xaxis.categories = yearsList;
    chartConfig.usersPerYear.options.xaxis.categories = yearsList;
    chartConfig.activeUsersPerMonth.options.xaxis.categories = m_labels;
    chartConfig.usersPerMonth.options.xaxis.categories = m_labels;
    chartConfig.activeUsersPerDay.options.xaxis.categories = daysList;
    chartConfig.usersPerDay.options.xaxis.categories = daysList;

    // Step 3: Dispatch all the state changes

    // Active members per day
    dispatch(actions.queryActiveUsersDay("active_users", "day", daysList));

    // Active members per month
    dispatch(actions.queryActiveUsersMonth("active_users", "month", monthList));

    // Active members per year
    dispatch(actions.queryActiveUsersYear("active_users", "year", yearsList));

    // App installations
    // dispatch(actions.queryAppInstallations("app_installations", "year", yearsList));

    // Registered users per year
    dispatch(actions.queryUsersPerYear("users_per_role", "year", yearsList));

    // Registered users per month
    dispatch(actions.queryUsersPerMonth("users_per_role", "month", monthList));

    // Registered users per day
    dispatch(actions.queryUsersPerDay("users_per_role", "day", daysList));
  }, [dispatch]);

  return (
    <>
      {pieRoleLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            
              <div className="col-xl-2 col-lg-4 my-5">
                <Card
                  className="col d-flex align-items-bottom"
                  style={{ height: "200px" }}
                >
                  <div className="row justify-content-center my-2">
                    <strong>Active users this year</strong>
                  </div>
                  <div className="row justify-content-center my-auto">
                    <div className="col d-flex align-items-end justify-content-center">
                      <strong className="display-4 m-0">{activeMembersYear}</strong>
                    </div>
                  </div>
                </Card>
              </div>
              <div className="col-xl-2 col-lg-4 my-5">
                <Card
                  className="col d-flex align-items-bottom"
                  style={{ height: "200px" }}
                >
                  <div className="row justify-content-center my-2">
                    <strong>Active users this month</strong>
                  </div>
                  <div className="row justify-content-center my-auto">
                    <div className="col d-flex align-items-end justify-content-center ">
                      <strong className="display-4 m-0">{activeMembersMonth}</strong>
                    </div>
                  </div>
                </Card>
              </div>
              <div className="col-xl-2 col-lg-4 my-5">
                <Card
                  className="col d-flex align-items-bottom"
                  style={{ height: "200px" }}
                >
                  <div className="row justify-content-center my-2">
                    <strong>Active users today</strong>
                  </div>
                  <div className="row justify-content-center my-auto">
                    <div className="col d-flex align-items-end justify-content-center ">
                      <strong className="display-4 m-0">{activeMembersToday}</strong>
                    </div>
                  </div>
                </Card>
              </div>

              <div className="col-xl-3 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "200px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Registered users today</strong>
                  </div>
                  <div className="row justify-content-center my-auto">
                    <div className="col d-flex align-items-end justify-content-center">
                      <strong className="display-4 m-0">{usersToday}</strong>
                    </div>
                  </div>
                </Card>
              </div>

              <div className="col-xl-3 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "200px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Total users</strong>
                  </div>
                  <div className="row justify-content-center my-auto">
                    <div className="col d-flex align-items-end justify-content-center">
                      <strong className="display-4 m-0">{usersTotal}</strong>
                    </div>
                  </div>
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Active users per year - Since 2019</strong>
                  </div>
                  <Chart
                    options={chartConfig.activeUsersPerYear.options || {}}
                    series={activeUsersPerYear?.series || {}}
                    type="line"
                    height={245} />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Active users per month - Last 12 months</strong>
                  </div>
                  <Chart
                    options={chartConfig.activeUsersPerMonth.options || {}}
                    series={activeUsersPerMonth?.series || {}}
                    type="line"
                    height={245} />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Active users per day - Last 30 days</strong>
                  </div>
                  <Chart
                    options={chartConfig.activeUsersPerDay.options || {}}
                    series={activeUsersPerDay?.series || {}}
                    type="line"
                    height={245}
                    />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Registered users per year - Since 2019</strong>
                  </div>
                  <Chart
                    options={chartConfig.usersPerYear.options || {}}
                    series={usersPerYear?.series || {}}
                    type="line"
                    height={245} />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card
                  className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}
                >
                  <div className="row justify-content-center my-2">
                    <strong>Registered users per month - Last 12 months</strong>
                  </div>
                  <Chart
                    options={chartConfig.usersPerMonth.options || {}}
                    series={usersPerMonth?.series || {}}
                    type="line"
                    height={245}
                  />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}>
                  <div className="row justify-content-center my-2">
                    <strong>Registered users per day - Last 30 days</strong>
                  </div>
                  <Chart
                    options={chartConfig.usersPerDay.options || {}}
                    series={usersPerDay?.series || {}}
                    type="line"
                    height={245}
                    />
                </Card>
              </div>

              <div className="col-xl-4 col-lg-6 my-5">
                <Card
                  className="col d-flex align-items-bottom"
                  style={{ height: "300px" }}
                >
                  <div className="row justify-content-center my-2">
                    <strong>Users per roles</strong>
                  </div>
                  <Chart
                    options={pieRole?.options || {}}
                    series={pieRole?.series || {}}
                    type="pie"
                    height={280}
                  />
                </Card>
              </div>
            
          </div>
        </div>
      )
      }
    </>
  );
}
